export type CsvColumn<T> = [title: string, value: (row: T) => string | number]

const DATE = new Intl.DateTimeFormat('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' })

export const csvDate = (iso: string | null): string => (iso ? DATE.format(new Date(iso)) : '')

// Email и названия вводят сами пользователи: значение с «=» или «+» в начале Excel выполнит как формулу.
function cell(value: string | number): string {
  const text = String(value)
  const safe = /^[=+\-@\t\r]/.test(text) ? `'${text}` : text
  return /[";\r\n]/.test(safe) ? `"${safe.replaceAll('"', '""')}"` : safe
}

export function buildCsv<T>(columns: CsvColumn<T>[], rows: T[]): string {
  const lines = [
    columns.map(([title]) => cell(title)).join(';'),
    ...rows.map((row) => columns.map(([, value]) => cell(value(row))).join(';')),
  ]
  return `﻿${lines.join('\n')}`
}

export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  setTimeout(() => URL.revokeObjectURL(url))
}
